// src/components/MultiRoomPage.js
import React from "react";
import Form from "../Form";
import "./MultiRoomPage.css";

export default function MultiRoomPage() {
  return (
    <div className="multiroom-page">
      <div className="multiroom-shell">
        <div className="multiroom-header">
          <div>
            <h1 className="multiroom-title">Multi-Room Analyzer</h1>
            <div className="multiroom-highlight">
              Capture two photos with the 11&quot; AI Stick visible to generate
              accurate measurements instantly.
            </div>
          </div>
        </div>

        <div className="multiroom-card">
          <Form />
        </div>
      </div>
    </div>
  );
}
